import {Loader} from 'mc/lib';
import {storeFromArea} from 'mc/lib/utils';
import * as PropTypes from 'prop-types';
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card, CardBlock, CardHeader} from 'reactstrap';
import {fetchPlatbaVratkyIfNeeded, PLATBA_VRATKA_LIST_AREA} from '../../actions/platbaActions';
import VratkaCardBlock from './VratkaCardBlock';

class PlatbaVratkyCard extends Component {

    static propTypes = {
        platba: PropTypes.object.isRequired,
    };

    componentDidMount() {
        this.fetchData(true);
    }

    componentDidUpdate() {
        this.fetchData(false);
    }

    fetchData(force) {
        const {platba, dispatch} = this.props;
        dispatch(fetchPlatbaVratkyIfNeeded(platba.id, force));
    }

    renderVratka = vratka => {
        const {platba} = this.props;
        return <VratkaCardBlock key={vratka.id} platba={platba} vratka={vratka}/>;
    };

    renderBody() {
        const {vratkaList} = this.props;
        if (vratkaList.isFetching) {
            return <Loader/>;
        }
        if (!vratkaList.fetched) {
            return null;
        }
        if (!vratkaList.rows.length) {
            return <CardBlock>
                <i>Platba nemá žádné vratky.</i>
            </CardBlock>;
        }
        return <div className="items-list bordered">
            {vratkaList.rows.map(this.renderVratka)}
        </div>;
    }

    render() {
        return (
            <Card>
                <CardHeader>
                    <h2>Vratky</h2>
                </CardHeader>
                {this.renderBody()}
            </Card>
        );
    }
}

const mapStateToProps = state => ({
    vratkaList: storeFromArea(state, PLATBA_VRATKA_LIST_AREA),
});

export default connect(mapStateToProps)(PlatbaVratkyCard);
